export * from './tooltip.module';
export { TooltipDirective } from './tooltip.directive';
